import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';

const LogoText = ({ organizationName }) => {
  // Estado para guardar la orientación actual
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  );

  useEffect(() => {
    const handleResize = () => {
      // Actualiza el estado según la comparación de ancho y alto
      setOrientation(window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Si es móvil, usamos un tamaño distinto según la orientación
  const fontSize = is.mobile()
    ? orientation === 'landscape'
      ? '1rem'
      : '0.75rem'
    : '1.2rem';

  return (
    <div className="m-0 p-0">
      <div id="logotext" className="d-block logo-text text-black mt-0 mb-0 pb-0" style={{ fontSize }}>
        {organizationName}
      </div>
    </div>
  );
};

LogoText.propTypes = {
  organizationName: PropTypes.string.isRequired,
};

export default LogoText;
